import { render } from "./AboutUs.vue?vue&type=template&id=2f372193&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=2f372193&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f372193"]])

export default __exports__